import api from './api';

export interface SearchResult {
  type: string;
  id: number;
  title: string;
  subtitle: string | null;
  url: string;
}

export interface SearchResponse {
  results: SearchResult[];
  total: number;
}

export const searchService = {
  search: async (q: string, limit: number = 20): Promise<SearchResponse> => {
    const response = await api.get<SearchResponse>('/search', {
      params: { q, limit },
    });
    return response.data;
  },
};
